module.exports = __webpack_public_path__ + "img/logo.b59577b9.png";